<div class="dropdown-tabs-wrapper">
  <div class="vertical-line"></div>
  <div class="dropdown-tab" *ngFor="let dropdown of dropdownConfig">
    <button class="dropdown-title" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu"
    [ngClass]="{'dropdown-active': dropdown.baseURL == baseURL}">
      <span>{{ dropdown.title }}</span>
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
    <mat-menu #menu="matMenu" class="mat-menu">
      <button mat-menu-item *ngFor="let link of dropdown.links" (click)="navigate(link.route)" >
        <mat-icon>{{ link.icon }}</mat-icon>
        <span>{{ link.label }}</span>
      </button>
    </mat-menu>
  </div>
</div>
